import { api, errMsg } from "@/lib/api";

const loadRazorpay = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

// Opens Razorpay Checkout for a server-created order; success is only reported after server verification.
export async function startPayment({ base, headers, payBody, description }) {
  const { data } = await api.post(`${base}/pay`, payBody || {}, { headers });
  if (!(await loadRazorpay())) throw new Error("Could not load the payment gateway. Check your internet connection and retry.");
  return new Promise((resolve) => {
    let lastError = null;
    const rz = new window.Razorpay({
      key: data.key_id,
      amount: data.amount,
      currency: data.currency,
      name: data.name,
      description,
      order_id: data.order_id,
      prefill: data.prefill,
      theme: { color: "#0F172A" },
      handler: async (resp) => {
        try {
          const r = await api.post(`${base}/verify-payment`, resp, { headers });
          resolve({ status: "paid", ...r.data });
        } catch (e) {
          resolve({ status: "verify_error", error: errMsg(e) });
        }
      },
      modal: { ondismiss: () => resolve({ status: lastError ? "failed" : "dismissed", error: lastError }) },
    });
    rz.on("payment.failed", (resp) => {
      lastError = resp?.error?.description || "Payment failed";
      api.post(`${base}/payment-failed`, { razorpay_order_id: data.order_id, error: lastError }, { headers }).catch(() => {});
    });
    rz.open();
  });
}
